import { definitions } from '@luxuryescapes/contract-svc-promo';

type VoucherCondition = definitions['VoucherConditionV1'];

export function hasVoucherConditionWithoutId(conditions: ReadonlyArray<VoucherCondition>): boolean {
  return conditions.some((condition) => !condition.id_voucher_condition);
}

/**
 * The conditions grid assigns temporary IDs to new rows so MUI DataGrid can
 * identify them. An ID in an update payload means the condition already
 * exists on that voucher, so omit IDs that were not loaded with the voucher.
 */
export function serializeVoucherConditions(
  conditions: Array<VoucherCondition>,
  existingConditionIds: ReadonlySet<string>,
): Array<VoucherCondition> {
  return conditions.map(({ id_voucher_condition, ...condition }) => {
    if (id_voucher_condition && existingConditionIds.has(id_voucher_condition)) {
      return { ...condition, id_voucher_condition };
    }

    return condition;
  });
}
